module.exports = __webpack_public_path__ + "media/images/facebook_share_image-a378fdfb66b45eda46962a9ca09cbc75.png";